var render, staticRenderFns
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51054bf0')) {
      api.createRecord('51054bf0', component.options)
    } else {
      api.reload('51054bf0', component.options)
    }
    
  }
}
component.options.__file = "packages/menu/src/submenu.vue"
export default component.exports